export const INTEGER_AGE_MESSAGE = "Please enter a valid integer";

/** True when empty or a non-negative whole number (no decimals). */
export const isValidIntegerAge = (value) => {
  if (value === null || value === undefined || value === "") return true;
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (trimmed === "") return true;
    if (/[.]/.test(trimmed)) return false;
    const num = Number(trimmed);
    return Number.isFinite(num) && Number.isInteger(num) && num >= 0;
  }
  if (typeof value !== "number" || !Number.isFinite(value)) return false;
  return Number.isInteger(value) && value >= 0;
};

export const integerAgeRules = [
  {
    validator: (_, value) => {
      if (isValidIntegerAge(value)) return Promise.resolve();
      return Promise.reject(new Error(INTEGER_AGE_MESSAGE));
    },
  },
];
